<div class="svi-switch-button">
  <button (click)="setButtonChoice(answerYes)" [ngClass]="{ active: this.state === answerYes }">
    {{ answerYes }}
  </button>
  <button (click)="setButtonChoice(answerNo)" [ngClass]="{ active: this.state === answerNo }">
    {{ answerNo }}
  </button>
</div>
